import { trkType } from "./CompileProject";
import { URL_AUDIO, URL_VIDEO } from "../../GPX/Resources";
import { blockLegacyGithubUpload } from "../../../util/Util";
import { readTrackCoordinate } from "../../../util/DetailedTrack";
export const ExportProject = async (
  projectName,
  markers,
  markerTypes,
  originMarker,
  destinationMarker,
  destinationSameAsOrigin,
  trkseg,
  importedTrack,
  parcoursType,
  uploadToGithub,
  customNavigationPoints
) => {
  const downloadTextFile = (text, name) => {
    const cleanText = text.replaceAll("base64,/", "base64/");
    const blob = new Blob([cleanText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = name;
    link.href = url;
    link.click();
  };

  const cleanText = (cleanGpx) => {
    return cleanGpx.replaceAll("base64,/", "base64/");
  };

  const GPXFile = `<?xml version="1.0" encoding="UTF-8" standalone="no" ?>
  <gpx creator="Mindful house" version="1.0">
    <metadata>
      <name><![CDATA[CIRCUIT ${projectName}]]></name>
      <type><![CDATA[${parcoursType}]]></type>
      <link href="https://mindful-house.net/">
        <text>Mindful house</text>
      </link>
        <customNavigationPoints><![CDATA[${JSON.stringify(
          customNavigationPoints
        )}]]></customNavigationPoints>
    </metadata>
    <!-- Points de départ -->
    ${markers
      .filter((marker) => marker.type === markerTypes.origin)
      .map(
        (marker) => `
            <wpt lat="${marker.lat}" lon="${
          marker.lng
        }" id="depart" id-marker="${marker.id}">
              ${
                marker.description &&
                `<description><![CDATA[${marker.description}]]></description>`
              }
              ${marker.title && `<title><![CDATA[${marker.title}]]></title>`}
            </wpt>
        `
      )
      .join("\n")}

      <!-- Points de destination -->
      ${markers
        .filter((marker) => marker.type === markerTypes.destination)
        .map(
          (marker) => `
              <wpt lat="${marker.lat}" lon="${
            marker.lng
          }" id="destination" id-marker="${marker.id}">
                ${
                  marker.description &&
                  `<description><![CDATA[${marker.description}]]></description>`
                }
                ${marker.title && `<title><![CDATA[${marker.title}]]></title>`}
              </wpt>
          `
        )
        .join("\n")}
    <!-- Points de Navigation -->
    ${markers
      .filter((marker) => marker.type === markerTypes.step)
      .map((marker) => {
        return `
                  <wpt lat="${marker.lat}" lon="${marker.lng}" id="step">
                  </wpt>
              `;
      })
      .join("\n")}
        
      <!-- Points d'intérêts touristiques -->
      ${markers
        .filter((marker) => marker.type === markerTypes.touristic)
        .map((marker) => {
          const imageNames = marker.imageName
            ? marker.imageName
                .map(
                  (imageName) =>
                    `<imageName><![CDATA[${imageName}]]></imageName>\n`
                )
                .join("\n")
            : "";
          const imagesrc = marker.image
            ? marker.image
                .map((image) => `<image><![CDATA[${image}]]></image>\n`)
                .join("\n")
            : "";
          const videoNames = marker.videoName
            ? marker.videoName
                .map(
                  (videoName) =>
                    `<videoName><![CDATA[${videoName}]]></videoName>\n`
                )
                .join("\n")
            : "";
          const videosrc = marker.video
            ? marker.video
                .map((video) => `<video><![CDATA[${video}]]></video>\n`)
                .join("\n")
            : "";
          const audioNames = marker.audioName
            ? marker.audioName
                .map(
                  (audioName) =>
                    `<audioName><![CDATA[${audioName}]]></audioName>\n`
                )
                .join("\n")
            : "";

          const audiosrc = marker.audio
            ? marker.audio.map(
                (audio) => `<audio><![CDATA[${audio}]]></audio>\n`
              )
            : "";
          const resourcesArray = marker.resourceArray
            ? marker.resourceArray.map(
                (resourceArray) =>
                  `<resourceArray><![CDATA[${resourceArray}]]></resourceArray>\n`
              )
            : "";
          const openQuestionArray = marker.openQuestionArray
            ? marker.openQuestionArray.map((questionObject) => {
                const {
                  question,
                  answer,
                  successMessage,
                  errorMessage,
                  neutralMessage,
                  noCorrectAnswer,
                } = questionObject;

                return `<openQuestionArray>
            <question><![CDATA[${question}]]></question>
            <answer><![CDATA[${answer}]]></answer>
            <successMessage><![CDATA[${successMessage}]]></successMessage>
            <errorMessage><![CDATA[${errorMessage}]]></errorMessage>
            <neutralMessage><![CDATA[${neutralMessage || ""}]]></neutralMessage>
            <noCorrectAnswer><![CDATA[${
              noCorrectAnswer || false
            }]]></noCorrectAnswer>
          </openQuestionArray>\n`;
              })
            : "";

          const qcmArray = marker.qcmArray
            ? marker.qcmArray
                .map((qcmItem) => {
                  const {
                    question,
                    answersArray,
                    correctAnswers,
                    successMessage,
                    errorMessage,
                    neutralMessage,
                    noCorrectAnswer,
                  } = qcmItem;

                  const answersString = answersArray
                    .map(
                      (answer) =>
                        `<answersArray><![CDATA[${answer}]]></answersArray>`
                    )
                    .join("\n");

                  const correctAnswersString = correctAnswers
                    .map(
                      (correct) =>
                        `<correctAnswers><![CDATA[${correct}]]></correctAnswers>`
                    )
                    .join("\n");

                  return `<qcmArray>
            <question><![CDATA[${question}]]></question>
            ${answersString}
            ${correctAnswersString}
            <successMessage><![CDATA[${successMessage}]]></successMessage>
            <errorMessage><![CDATA[${errorMessage}]]></errorMessage>
            <neutralMessage><![CDATA[${neutralMessage || ""}]]></neutralMessage>
            <noCorrectAnswer><![CDATA[${
              noCorrectAnswer || false
            }]]></noCorrectAnswer>
          </qcmArray>`;
                })
                .join("\n")
            : "";

          const qcmImageArray = marker.qcmImageArray
            ? marker.qcmImageArray
                .map((qcmImageItem) => {
                  const {
                    question,
                    answersTitleArray,
                    answersArray,
                    correctAnswers,
                    successMessage,
                    errorMessage,
                    neutralMessage,
                    noCorrectAnswer,
                    imageName,
                  } = qcmImageItem;

                  const answersString = answersArray
                    .map(
                      (answer) =>
                        `<answersArray><![CDATA[${answer}]]></answersArray>`
                    )
                    .join("\n");

                  const titlesString = answersTitleArray
                    .map(
                      (title) =>
                        `<answersTitleArray><![CDATA[${title}]]></answersTitleArray>`
                    )
                    .join("\n");

                  const correctAnswersString = correctAnswers
                    .map(
                      (correct) =>
                        `<correctAnswers><![CDATA[${correct}]]></correctAnswers>`
                    )
                    .join("\n");

                  return `<qcmImageArray>
            <question><![CDATA[${question}]]></question>
            ${answersString}
            ${titlesString}
            ${correctAnswersString}
            <successMessage><![CDATA[${successMessage}]]></successMessage>
            <errorMessage><![CDATA[${errorMessage}]]></errorMessage>
            <neutralMessage><![CDATA[${neutralMessage || ""}]]></neutralMessage>
            <noCorrectAnswer><![CDATA[${
              noCorrectAnswer || false
            }]]></noCorrectAnswer>
            <imageName><![CDATA[${imageName}]]></imageName>
          </qcmImageArray>`;
                })
                .join("\n")
            : "";

          return `
            <wpt lat="${marker.lat}" lon="${
            marker.lng
          }" id="touristic" id-marker="${marker.id}">
            ${
              marker.description &&
              `<description><![CDATA[${marker.description}]]></description>`
            }
              ${marker.title && `<title><![CDATA[${marker.title}]]></title>`}
              ${imagesrc}
              ${imageNames}
              ${videosrc}
              ${videoNames}
              ${audiosrc}
              ${audioNames}
              ${resourcesArray}
              ${openQuestionArray}
              ${qcmArray}
              ${qcmImageArray}
              <mainResource><![CDATA[${marker.mainResource}]]></mainResource>
              <checkAcces><![CDATA[${marker.checkAcces}]]></checkAcces>
              <triggerType><![CDATA[${marker.triggerType}]]></triggerType>
              <triggerDistance><![CDATA[${
                marker.triggerDistance
              }]]></triggerDistance>
              <url><![CDATA[${marker.url}]]></url>
              ${
                marker.iconImage &&
                `<iconImage><![CDATA[${marker.iconImage}]]></iconImage>`
              }
              ${
                marker.iconNameWithoutBorder &&
                `<iconNameWithoutBorder><![CDATA[${marker.iconNameWithoutBorder}]]></iconNameWithoutBorder>`
              }
              ${
                marker.iconName &&
                `<iconName><![CDATA[${marker.iconName}]]></iconName>`
              }
            </wpt>
          `;
        })
        .join("\n")}
      
      

      <!--Points d'information-->
      ${markers
        .map((marker) => {
          if (marker.type.includes("info")) {
            return `
            <wpt lat="${marker.lat}" lon="${
              marker.lng
            }" id="information" id-marker="${marker.id}">
            ${
              marker.description &&
              `<description><![CDATA[${marker.description}]]></description>`
            }
              ${marker.title && `<title><![CDATA[${marker.title}]]></title>`}
              <subType><![CDATA[${marker.subType}]]></subType>
            </wpt>
            `;
          }
          return "";
        })
        .join("\n")}

  <!-- Séparer les deux types de points : importés et classiques -->
${(() => {
  const classicTrack = trkseg.filter(
    (pt) =>
      pt &&
      Number.isFinite(readTrackCoordinate(pt, "lat")) &&
      Number.isFinite(readTrackCoordinate(pt, "lng"))
  );

  const getSafeCoord = (coord) =>
    typeof coord === "function" ? coord() : coord;

  const trackClassic = classicTrack.length
    ? `<trk>
<name><![CDATA[Parcours Classique]]></name>
<desc><![CDATA[]]></desc>
<type>Indéfini</type>
<extensions>
  <om:oruxmapsextensions xmlns:om="http://www.oruxmaps.com/oruxmapsextensions/1/0">
    <om:ext type="TYPE" subtype="0">0</om:ext>
    <om:ext type="DIFFICULTY">0</om:ext>
    <om:ext type="COLOR">${trkType(parcoursType)}</om:ext>
  </om:oruxmapsextensions>
</extensions>
<trkseg>
  <trkpt lat="${getSafeCoord(originMarker.lat)}" lon="${getSafeCoord(
        originMarker.lng
      )}"></trkpt>
  ${classicTrack
    .map((location) => {
      const lat = readTrackCoordinate(location, "lat");
      const lng = readTrackCoordinate(location, "lng");
      return `<trkpt lat="${lat}" lon="${lng}"></trkpt>`;
    })
    .join("")}
  ${
    destinationSameAsOrigin
      ? `<trkpt lat="${getSafeCoord(originMarker.lat)}" lon="${getSafeCoord(
          originMarker.lng
        )}"></trkpt>`
      : `<trkpt lat="${getSafeCoord(
          destinationMarker.lat
        )}" lon="${getSafeCoord(destinationMarker.lng)}"></trkpt>`
  }
</trkseg>
</trk>`
    : "";

  const trackImported = importedTrack.length
    ? `<trk>
<name><![CDATA[Trace Importée]]></name>
<desc><![CDATA[]]></desc>
<type>Importée</type>
<extensions>
  <om:oruxmapsextensions xmlns:om="http://www.oruxmaps.com/oruxmapsextensions/1/0">
    <om:ext type="TYPE" subtype="1">1</om:ext>
    <om:ext type="DIFFICULTY">0</om:ext>
    <om:ext type="COLOR">#FF0000</om:ext>
  </om:oruxmapsextensions>
</extensions>
<trkseg>
  ${importedTrack
    .map((pt) => `<trkpt lat="${pt.lat}" lon="${pt.lng}"></trkpt>`)
    .join("")}
</trkseg>
</trk>`
    : "";

  return trackClassic + "\n" + trackImported;
})()}
  </gpx>`;

  if (uploadToGithub) {
    try {
      // Ce chemin historique reste fermé jusqu'au raccordement OCI.
      await blockLegacyGithubUpload();
    } catch (error) {
      console.error("Stockage externe indisponible :", error);
    }
  } else {
    // Si uploadToGithub est faux, télécharger uniquement le fichier localement
    const fileName = `${projectName}.gpx`;
    console.log("GPX File Content:", GPXFile);
    downloadTextFile(GPXFile, fileName);
  }
};
